// FIXME: Need to be refactored
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'
import { LensRounded } from '@material-ui/icons'
import Countdown from '../Countdown/Countdown.container'
import { onGetServerStatusThunk } from '../Countdown/Countdown.actions'
import { SERVICE_HEALTH } from '../../store/models/status'
import { Body, Card, Header } from './ServerStatus.styles'

const HEALTH_LABEL = {
  [SERVICE_HEALTH.OPERATIONAL]: 'OPERACIONAL',
  [SERVICE_HEALTH.DEGRADED]: 'DEGRADADO',
  [SERVICE_HEALTH.DOWN]: 'INTERRUPCIÓN TOTAL'
}

const SOURCE_LABEL = {
  gps: 'GPS',
  loads: 'Loads',
  dispatch: 'FMSDiesel',
  orpak: 'Fluidintel'
}

// Native tooltip for the health badge, e.g. "GPS: OK · Loads: OK · FMSDiesel: OK · Fluidintel: Caído"
const describeSources = sources => {
  if (!sources) {
    return undefined
  }
  return Object.entries(SOURCE_LABEL)
    .map(([key, label]) => `${label}: ${sources[key] ? 'OK' : 'Caído'}`)
    .join(' · ')
}

/**
 * The Server status' container.
 * Reads from the countdown' store slice, kept fresh by the Countdown websocket:
 * re-fetched on mount and again every time a "full message" (trucks array) arrives,
 * so it follows whatever the real push cadence is instead of a guessed timer.
 */
const ServerStatus = () => {
  const dispatch = useDispatch()
  const { health, sources } = useSelector(state => state.countdown.serverStatus)

  useEffect(() => {
    dispatch(onGetServerStatusThunk())
  }, [dispatch])

  return (
    <Card>
      <Header health={health} title={describeSources(sources)}>
        <LensRounded style={{ color: 'white', fontSize: '14px' }} />
        <Typography style={{ color: 'white', fontSize: '0.85rem', fontWeight: 'bold' }}>
          {`ESTADO: ${HEALTH_LABEL[health]}`}
        </Typography>
      </Header>
      <Body>
        <Countdown />
      </Body>
    </Card>
  )
}

export default ServerStatus
